/*
 * Candidate Behaviour Tab Messages
 *
 * This contains all the text for the Candidate Behaviour Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateBehaviourTab';

export default defineMessages({
  generalTitle: {
    id: `${scope}.generalTitle`,
    defaultMessage: 'General',
  },
  applicationBehaviourTitle: {
    id: `${scope}.applicationBehaviourTitle`,
    defaultMessage: 'Application Behaviour',
  },
  cancellationBehaviourTitle: {
    id: `${scope}.cancellationBehaviourTitle`,
    defaultMessage: 'Cancellation Behaviour',
  },
  jobBehaviourTitle: {
    id: `${scope}.jobBehaviourTitle`,
    defaultMessage: 'Job Behaviour',
  },
  averageJobRating: {
    id: `${scope}.averageJobRating`,
    defaultMessage: 'Average Job Rating',
  },
  annualCompletedShifts: {
    id: `${scope}.annualCompletedShifts`,
    defaultMessage: 'Annual completed shifts',
  },
  annualWorkdayLeft: {
    id: `${scope}.annualWorkdayLeft`,
    defaultMessage: 'Annual Workday Left',
  },
  applicationBookingRatio: {
    id: `${scope}.applicationBookingRatio`,
    defaultMessage: 'Application Booking Ratio',
  },
  jobConfirmationTime: {
    id: `${scope}.jobConfirmationTime`,
    defaultMessage: 'Job Confirmation Time',
  },
  bookingCancellationRatio: {
    id: `${scope}.bookingCancellationRatio`,
    defaultMessage: 'Booking Cancellation Ratio',
  },
  timelyCancellationRatio: {
    id: `${scope}.timelyCancellationRatio`,
    defaultMessage: 'Timely Cancellation Ratio',
  },
  justifiedCancellationRatio: {
    id: `${scope}.justifiedCancellationRatio`,
    defaultMessage: 'Justified Cancellation Ratio',
  },
  unjustifiedCancellationRatio: {
    id: `${scope}.unjustifiedCancellationRatio`,
    defaultMessage: 'Unjustified Cancellation Ratio',
  },
  bookingCancellationRatioTooltip: {
    id: `${scope}.bookingCancellationRatioTooltip`,
    defaultMessage:
      'Share of booked shifts the candidate cancelled in the last 12 months. Cancelled shifts / booked shifts. Not counted: cancellations by UCM or the customer, mutual cancellations and transferred shifts.',
  },
  timelyCancellationRatioTooltip: {
    id: `${scope}.timelyCancellationRatioTooltip`,
    defaultMessage:
      "Share of the candidate's cancellations made at least 96 hours before the first affected shift, in the last 12 months. Timely cancellations / all cancellations.",
  },
  justifiedCancellationRatioTooltip: {
    id: `${scope}.justifiedCancellationRatioTooltip`,
    defaultMessage:
      'Share of booked shifts cancelled with a valid, approved proof (e.g. sick note) in the last 12 months. Cancelled shifts with approved proof / booked shifts. Together with the Unjustified Cancellation Ratio, it adds up to the Booking Cancellation Ratio.',
  },
  unjustifiedCancellationRatioTooltip: {
    id: `${scope}.unjustifiedCancellationRatioTooltip`,
    defaultMessage:
      'Share of booked shifts cancelled without a valid reason in the last 12 months. Cancelled shifts / booked shifts, for: no-show, fake check-in, behaviour, other, or a missing, rejected or not yet approved proof. Once a proof is approved, the shift moves to Justified. Together with the Justified Cancellation Ratio, it adds up to the Booking Cancellation Ratio.',
  },
  userInfringedDeviations: {
    id: `${scope}.userInfringedDeviations`,
    defaultMessage: 'User infringed Deviations',
  },
});
